import { axios } from 'services/axios'
import { routes } from 'services/routes'

import { getBrowserInfo } from './utils'

import type { CreateTrackingEventParams } from './types'

export const createTrackingEvent = async ({
  name,
  properties,
}: CreateTrackingEventParams) => {
  const response = await axios.post<object>(routes.eventsPath(), {
    browser: getBrowserInfo(),
    name,
    properties,
    timestamp: new Date().toISOString(),
  })

  if (!response) {
    throw new Error('Couldn\'t create event')
  }

  return response.data
}
